import { Component } from '@angular/core';

@Component({
  selector: 'app-two-faotp',
  templateUrl: './two-faotp.component.html',
  styleUrls: ['./two-faotp.component.scss']
})
export class TwoFaotpComponent {

}
